// extracted by mini-css-extract-plugin
module.exports = {"card":"card--1ire6"};